import { type PropsWithChildren } from "react";

import { icons } from "./Icons";

export const FieldError = ({
  id,
  children,
}: PropsWithChildren<{ id?: string }>) => (
  <p
    id={id}
    role="alert"
    aria-live="assertive"
    className="flex items-center gap-1.5 pt-1 text-sm text-red-500"
  >
    <icons.outline.ExclamationCircleIcon className="size-4 shrink-0" />
    {children}
  </p>
);
